import {
  CreateSaleInput,
  UpdateSaleInput,
} from "@towersystems/roam-common/lib/generated-types";
import { createContext } from "react";
import Sale from "../data/model/Sale";

export interface SyncSaleContextType {
  running: boolean;
  addSaleToQueue(saleId: string): Promise<boolean>;
  processAndSyncSaleById(saleId: string): Promise<void>;
  removeItemFromQueue(saleId: string): Promise<void>;
  formatSale(sale: Sale): Promise<CreateSaleInput | UpdateSaleInput>;
}

export const SyncSaleContext = createContext<SyncSaleContextType | undefined>(
  undefined
);
